import { Dayjs } from "dayjs";

/**
 * Users drawer filters.
 * yes/no fields use "" | "yes" | "no".
 * Age fields use encoded values, e.g. "lte:30", "gt:365", "none".
 */
export type UsersFiltersState = {
  role: string;
  pending: string;
  hasPhone: string;
  emailDomain: string;
  multiRole: string;
  joinedAge: string;
  updatedAge: string;
  joinedFrom: Dayjs | null;
  joinedTo: Dayjs | null;
  updatedFrom: Dayjs | null;
  updatedTo: Dayjs | null;
};

export const EMPTY_USERS_FILTERS: UsersFiltersState = {
  role: "",
  pending: "",
  hasPhone: "",
  emailDomain: "",
  multiRole: "",
  joinedAge: "",
  updatedAge: "",
  joinedFrom: null,
  joinedTo: null,
  updatedFrom: null,
  updatedTo: null,
};

export const YES_NO_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
] as const;

export const PENDING_OPTIONS = [
  { value: "yes", label: "Pending" },
  { value: "no", label: "Not pending" },
] as const;

export const MULTI_ROLE_OPTIONS = [
  { value: "yes", label: "Multiple roles" },
  { value: "no", label: "Single role" },
] as const;

export type AgeOption = {
  value: string;
  label: string;
};

/** Encoded age presets in days: lte:N, gt:N, or none. */
export const AGE_OPTIONS: AgeOption[] = [
  { value: "lte:7", label: "Within 7 days" },
  { value: "lte:30", label: "Within 30 days" },
  { value: "lte:90", label: "Within 90 days" },
  { value: "lte:180", label: "Within 6 months" },
  { value: "lte:365", label: "Within 1 year" },
  { value: "gt:365", label: "Older than 1 year" },
  { value: "none", label: "No date" },
];

export const FILTER_FIELD_LABELS: Record<keyof UsersFiltersState, string> = {
  role: "Role",
  pending: "Pending",
  hasPhone: "Has phone",
  emailDomain: "Email domain",
  multiRole: "Roles count",
  joinedAge: "Joined",
  updatedAge: "Last updated",
  joinedFrom: "Joined from",
  joinedTo: "Joined to",
  updatedFrom: "Last updated from",
  updatedTo: "Last updated to",
};

export function ageOptionLabel(value: string): string {
  return AGE_OPTIONS.find((o) => o.value === value)?.label ?? value;
}
